function normalizePath(path = "") {
  return path.startsWith("/") ? path : `/${path}`;
}

function normalizeBaseUrl() {
  return String(process.env.VUE_APP_BASE_URL || "").trim().replace(/\/+$/, "");
}

function baseAlreadyHasWx(baseUrl) {
  return /\/wx$/i.test(baseUrl);
}

export function buildUploadUrl(path = "/api/upload") {
  const normalizedPath = normalizePath(path);
  const baseUrl = normalizeBaseUrl();

  if (!baseUrl) {
    return `/wx${normalizedPath}`;
  }

  return baseAlreadyHasWx(baseUrl)
    ? `${baseUrl}${normalizedPath}`
    : `${baseUrl}/wx${normalizedPath}`;
}

export function buildRequestPath(path = "/api/upload") {
  const normalizedPath = normalizePath(path);
  return baseAlreadyHasWx(normalizeBaseUrl()) ? normalizedPath : `/wx${normalizedPath}`;
}
